var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 207,
    viewBox: "0 0 241 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 25.0325C24.5 23.9153 25.4152 23.0148 26.5323 23.0328L209.224 25.9794C210.002 25.992 210.702 26.4549 211.019 27.166L240.389 93.1578C240.509 93.4278 240.568 93.721 240.561 94.0164L238 207H98.5L25.2662 149.601C24.7825 149.221 24.5 148.641 24.5 148.026V25.0325Z",
    fill: "url(#paint0_linear_1846_145852)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.315 20.5801H28.6983C24.9668 20.5801 21.6875 23.8593 21.6875 27.5909V144.287C21.6875 148.019 24.9668 146.662 28.6983 146.662H197.863C201.594 146.662 204.874 148.019 204.874 144.287V27.5909C205.326 23.8593 202.047 20.5801 198.315 20.5801Z",
    fill: "#D5DDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.697 140.105V143.837C226.697 148.021 222.965 151.752 218.781 151.752H8.34319C4.1593 151.752 0.427734 148.021 0.427734 143.837V140.105H226.697Z",
    fill: "#CED7E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.216 140.105V141.462C135.216 143.837 133.407 146.099 130.58 146.099H96.0913C93.7166 146.099 91.4551 144.289 91.4551 141.462V140.105H135.216Z",
    fill: "#E9EFF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.083 35.8487V128.346C184.857 132.191 181.804 135.357 177.846 135.357H40.7956C36.7248 135.357 33.5586 132.191 33.5586 128.346V35.8487C33.5586 32.0041 36.7248 28.8379 40.7956 28.8379H177.959C182.03 28.8379 185.083 32.0041 185.083 35.8487Z",
    fill: "url(#paint1_linear_1846_145852)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8139 39.4657C43.1708 39.4657 44.3016 38.3349 44.3016 36.9779C44.3016 35.621 43.1708 34.4902 41.8139 34.4902C40.4569 34.4902 39.3262 35.621 39.3262 36.9779C39.3262 38.3349 40.4569 39.4657 41.8139 39.4657Z",
    fill: "#D6DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1635 39.4657C50.5204 39.4657 51.6512 38.3349 51.6512 36.9779C51.6512 35.621 50.5204 34.4902 49.1635 34.4902C47.8066 34.4902 46.6758 35.621 46.6758 36.9779C46.6758 38.3349 47.8066 39.4657 49.1635 39.4657Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7397 39.4657C58.0966 39.4657 59.2274 38.3349 59.2274 36.9779C59.2274 35.621 58.0966 34.4902 56.7397 34.4902C55.3827 34.4902 54.252 35.621 54.252 36.9779C54.252 38.3349 55.3827 39.4657 56.7397 39.4657Z",
    fill: "#F1F3F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M200.688 20.3565V112.854C200.688 112.967 200.688 113.193 200.688 113.307C200.349 117.038 197.296 119.865 193.565 119.865H56.401C52.3302 119.865 49.1641 116.699 49.1641 112.854V20.3565C49.1641 16.5119 52.3302 13.3457 56.401 13.3457H193.565C197.635 13.3457 200.688 16.3988 200.688 20.3565Z",
    fill: "url(#paint2_linear_1846_145852)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4194 23.9735C58.7763 23.9735 59.9071 22.8427 59.9071 21.4858C59.9071 20.1288 58.7763 18.998 57.4194 18.998C56.0624 18.998 54.9316 20.1288 54.9316 21.4858C54.9316 22.8427 56.0624 23.9735 57.4194 23.9735Z",
    fill: "#D6DCE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.769 23.9735C66.1259 23.9735 67.2567 22.8427 67.2567 21.4858C67.2567 20.1288 66.1259 18.998 64.769 18.998C63.412 18.998 62.2812 20.1288 62.2812 21.4858C62.2812 22.8427 63.412 23.9735 64.769 23.9735Z",
    fill: "#D6DCE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3451 23.9735C73.7021 23.9735 74.8328 22.8427 74.8328 21.4858C74.8328 20.1288 73.7021 18.998 72.3451 18.998C70.9882 18.998 69.8574 20.1288 69.8574 21.4858C69.8574 22.8427 70.9882 23.9735 72.3451 23.9735Z",
    fill: "#F1F3F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.745 99.5085C216.519 103.353 213.466 106.519 209.508 106.519H72.4577C68.3869 106.519 65.2207 103.353 65.2207 99.5085V7.01083C65.2207 3.16618 68.3869 0 72.4577 0H209.621C213.692 0 216.858 3.16618 216.858 7.01083V99.5085H216.745Z",
    fill: "url(#paint3_linear_1846_145852)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.476 10.7408C74.8329 10.7408 75.9637 9.61007 75.9637 8.25314C75.9637 6.8962 74.8329 5.65234 73.476 5.65234C72.1191 5.65234 70.9883 6.78312 70.9883 8.14006C70.9883 9.49699 72.1191 10.7408 73.476 10.7408Z",
    fill: "#D7DBE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8256 10.7408C82.1825 10.7408 83.3133 9.61007 83.3133 8.25314C83.3133 6.8962 82.1825 5.65234 80.8256 5.65234C79.4687 5.65234 78.3379 6.78312 78.3379 8.14006C78.3379 9.49699 79.4687 10.7408 80.8256 10.7408Z",
    fill: "#D7DBE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4018 10.7408C89.7587 10.7408 90.8895 9.61007 90.8895 8.25314C90.8895 6.8962 89.7587 5.65234 88.4018 5.65234C87.0448 5.65234 85.9141 6.78312 85.9141 8.14006C85.9141 9.49699 86.9318 10.7408 88.4018 10.7408Z",
    fill: "#D7DBE4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.662 21.2695H156.635C158.105 21.2695 159.462 21.8349 160.48 22.8526L177.441 39.8143C178.459 40.832 179.024 42.1889 179.024 43.659V67.5184C179.024 68.9884 178.459 70.3453 177.441 71.363L160.706 88.0985C159.688 89.1162 158.331 89.6816 156.861 89.6816H132.662C131.192 89.6816 129.836 89.1162 128.818 88.0985L111.63 70.9107C110.612 69.893 110.047 68.5361 110.047 67.0661V43.659C110.047 42.1889 110.612 40.832 111.63 39.8143L128.705 22.8526C129.836 21.8349 131.192 21.2695 132.662 21.2695Z",
    fill: "url(#paint4_linear_1846_145852)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.606 34.8835V46.2313C148.606 46.9878 148.606 47.7443 148.493 48.6089L147.25 56.7145C147.136 57.363 146.571 57.9033 145.78 57.9033H143.292C142.613 57.9033 141.935 57.363 141.822 56.7145L140.578 48.6089C140.465 47.8524 140.465 47.0959 140.465 46.2313V34.8835C140.465 34.127 141.143 33.4785 141.935 33.4785H147.25C147.928 33.5866 148.606 34.127 148.606 34.8835Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.249 74.9781H141.708C140.803 74.9781 140.012 74.1865 140.012 73.2819V67.7411C140.012 66.8365 140.803 66.0449 141.708 66.0449H147.249C148.153 66.0449 148.945 66.8365 148.945 67.7411V73.2819C148.945 74.1865 148.153 74.9781 147.249 74.9781Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1846_145852",
    x1: 292,
    y1: 100.5,
    x2: 159.196,
    y2: -40.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4B0D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1846_145852",
    x1: 41.0951,
    y1: 21.5449,
    x2: 30.7228,
    y2: 118.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE2EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1846_145852",
    x1: 56.7006,
    y1: 6.05272,
    x2: 46.3283,
    y2: 103.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6EBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1846_145852",
    x1: 72.7628,
    y1: -7.29299,
    x2: 62.3981,
    y2: 89.7411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1846_145852",
    x1: 112.527,
    y1: 22.3121,
    x2: 106.705,
    y2: 81.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.670e96cc278c8d3fe332b920319268f3.svg";
export { ForwardRef as ReactComponent };